import React, { useEffect } from "react";
import { useCurrentRefinements } from "react-instantsearch";

import filtersConfig from "./../../../Config/filtersConfig";

import { useDispatch } from "react-redux";
import { facetsActions } from "../../../store/redux/store";
import "./CustomCurrentRefinements.scss";

const CustomCurrentRefinements = (props) => {
    const { items, refine } = useCurrentRefinements(props);

    const dispatch = useDispatch();
    const pushCollectedFacets = (payload) => {
        dispatch(facetsActions.pushFacets(payload));
    };
    const resetCollectionsFacets = () => {
        dispatch(facetsActions.resetFacets());
    };
    useEffect(
        () => {
            resetCollectionsFacets();
            items.length > 0 &&
                items.map((item, index) => {
                    return item.refinements.map((refinementOption, index) => {
                        return pushCollectedFacets(refinementOption.value);
                    });
                });
        },
        // eslint-disable-next-line
        [items],
    );

    const getMatchingLabel = (item) => {
        let labels = null;
        // grab the Array item which matchs the id "2"
        labels = filtersConfig.find(
            (element) => element.name === item.attribute,
        );
        if (labels) {
            return labels.label;
        } else {
            const groups = filtersConfig
                .filter((element, index) => element.type === "group")
                .map((element, index) => element.group);

            const groupsFlatted = Object.values(groups).flat();
            labels = groupsFlatted.find(
                (element) => element.name === item.attribute,
            );
            return labels.label;
        }
    };
    const transformItems = (item, index) => {
        return (
            <span key={index} className="ais-CurrentRefinements-label">
                {getMatchingLabel(item)}:
            </span>
        );
    };
    const transformRefinement = (item) => {
        switch (item.attribute) {
            case "priceNumeric":
                return (
                    item.label.replace("≤", "bis zu ").replace("≥", "ab") + " €"
                );
            case "detail_shippingTimeInDays":
                return item.label.replace("≤", "bis zu ") + " Tage";

            default:
                return item.label;
        }
    };
    useEffect(() => {
        items.length > 0
            ? (document.getElementsByTagName("meta")["robots"].content =
                  "noindex, follow")
            : (document.getElementsByTagName("meta")["robots"].content =
                  "index, follow");
    }, [items]);
    const refinementItems = items.map((item, index) => {
        return (
            <li key={index} className="ais-CurrentRefinements-item">
                {transformItems(item)}
                {item.refinements.map((refinementOption, index) => {
                    return (
                        <span
                            key={index}
                            className="ais-CurrentRefinements-category"
                        >
                            <button
                                type="button"
                                className="ais-CurrentRefinements-delete"
                                onClick={(event) => {
                                    event.preventDefault();
                                    refine(refinementOption);
                                }}
                            >
                                <span className="ais-CurrentRefinements-categoryLabel">
                                    {transformRefinement(refinementOption)}
                                </span>
                                ✕
                            </button>
                        </span>
                    );
                })}
            </li>
        );
    });


    return (
        <div className="search-refinements__item">
            <ul className="ais-CurrentRefinements-list">{refinementItems}</ul>
        </div>
    );
};

export default CustomCurrentRefinements;
